/** Public marketing copy for /unifi-networks (non-technical). */

export const unifiNetworksContent = {
  eyebrow: "UniFi network services",
  title: "Wi‑Fi and wiring that work the first time - and keep working.",
  lead:
    "From a fresh office build-out to fixing what you already have, we design, install, and support UniFi networks: strong coverage, clean guest Wi‑Fi, smart segmentation, remote access, and security cameras - all with a support desk you can actually follow.",
  heroPoints: [
    "New installs or upgrades on your existing gear",
    "Guest Wi‑Fi, VLANs, VPN, and cameras on one trusted platform",
    "Report issues and track fixes in our ticketing portal",
  ],
  features: [
    {
      id: "install",
      title: "Installs - new or built on what you have",
      body:
        "Greenfield rollouts or retrofitting an existing site: cabling, drops, rack layout, access points, switches, and gateways configured and documented so your team knows what’s where.",
      icon: "install",
    },
    {
      id: "wireless",
      title: "Wi‑Fi that guests and staff both trust",
      body:
        "Primary wireless, guest networks, and secondary WLANs - tuned for coverage and capacity so visitors get internet without touching your internal systems.",
      icon: "wireless",
    },
    {
      id: "segment",
      title: "LAN, VLANs, and remote access",
      body:
        "Logical network layout, VLAN segmentation, and offsite VPN so staff and owners reach what they need securely - without opening the whole network to everyone.",
      icon: "segment",
    },
    {
      id: "security",
      title: "Cameras and peace of mind",
      body:
        "UniFi Protect cameras integrated with the same ecosystem you already manage - recording, alerts, and storage planned around your building, not a one-size-fits-all kit.",
      icon: "security",
    },
  ],
  capabilities: {
    title: "What we configure on UniFi",
    chips: [
      "Network drops",
      "Guest Wi‑Fi",
      "Secondary WLAN",
      "LAN layout",
      "VLAN segmentation",
      "Offsite VPN",
      "Security cameras",
      "Switches & routers",
      "NAS / NVR",
    ],
  },
  unifiStack: {
    title: "One platform: UniFi end to end",
    body:
      "We standardize on Ubiquiti UniFi for wireless, switching, routing, and Protect cameras - so updates, monitoring, and support all speak the same language.",
  },
  support: {
    title: "Already have a network? We’ve got you.",
    body:
      "Bring your own UniFi - or mixed - environment. We troubleshoot slow Wi‑Fi, roaming issues, misconfigured VLANs, and hardware problems across networks, switches, routers, NAS, NVR, access points, and related gear.",
    points: [
      "Diagnostics and remediation - not just a new bill of materials",
      "Ongoing support plans for sites we installed or inherited",
      "Clear recommendations when an upgrade beats another patch",
    ],
  },
  ticketing: {
    title: "Report an issue. Follow it to resolution.",
    subtitle:
      "Open a ticket from your site or our portal and watch status, next steps, and notes update in one place - no chasing email threads.",
    businessName: "Your site",
    metrics: {
      openTickets: "3",
      resolvedMonth: "24",
      avgUpdate: "4h",
    },
    activeTickets: [
      {
        id: "NET-1042",
        state: "In progress",
        snippet: "Guest Wi‑Fi slow in west wing - AP channel plan adjusted",
      },
      {
        id: "NET-1038",
        state: "Awaiting you",
        snippet: "Confirm after-hours window for VLAN change",
      },
    ],
    recent: [
      {
        id: "NET-1031",
        topic: "VPN access",
        outcome: "Resolved",
        response: "Remote worker profile enabled; tested from home",
        time: "Yesterday",
      },
      {
        id: "NET-1024",
        topic: "New drop",
        outcome: "Resolved",
        response: "Office 204 wall port live on staff VLAN",
        time: "3 days ago",
      },
      {
        id: "NET-1019",
        topic: "Camera offline",
        outcome: "Resolved",
        response: "NVR disk alert cleared; recording verified",
        time: "1 week ago",
      },
    ],
    liveBadge: "Updated",
  },
  cta: {
    primary: "Schedule a network consult",
    secondary: "View pricing",
  },
};
